import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import InputControl from '~/components/Input/InputControl';
import InputSelect from '~/components/Input/InputSelect';

import { editFilter } from '../../../../store/actions';

function SelectEnum({
  filter,
  column,
  indexGroup,
  indexFilter,
  inputProps,
}) {
  const dispatch = useDispatch();
  const options = useMemo(
    () => column._enum_().array,
    [column._enum_]
  );

  return (
    <InputControl
      value={filter.get('val')}
      name={'val'}
      inputComponent={InputSelect}
      InputProps={{
        placeholder: 'Selecione o valor',
        outValueType: 'string',
        options,
        ...inputProps,
      }}
      onChange={({ val }) => dispatch(editFilter(indexGroup, indexFilter, 'val', val))}
    />
  );
}

export default React.memo(SelectEnum);
